<template>
  <div v-if="appendData" nav-mode="light">
    <div v-if="busy" class="row text-center">
      <lottie-player
        autoplay
        loop
        speed="2.5"
        src="/img/animations/custom_loader.json"
        style="height: 130px;"
      >
      </lottie-player>
    </div>

    <div v-if="!busy" class="row my-3">
      <div class="col-md-8 offset-2">
        <NetworkMessageForm :network="network" :message="message" :reusedContent=reusedMessage?.content @form-updated="formUpdated" @network-message-form-submit="$router.push('/networks/' + slug + '/messages')" />
      </div>
    </div>
  </div>
</template>
<script>
import NetworkMessageForm from './NetworkMessageForm.vue';

export default {
  name: 'NetworkHome',
  components: {
    NetworkMessageForm,
  },
  props: {
    slug: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    reusedMessage: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      busy: true,
      network: null,
      formLeaveWithoutSave: false,
      message: null,
    };
  },
  computed: {
    appendData() {
      if (this.id !== null) {
        return this.network && this.message;
      } else {
        return this.network;
      }
    },
  },
  watch: {
    slug(newV) {
      if (newV != this.network.slug) this.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
  beforeRouteLeave(to) {
    if (this.formLeaveWithoutSave) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!');
      if (answer) {
        window.location.href = to.path;
      } else {
        return false;
      }
    } else {
      window.location.href = to.path;
    }
  },
  methods: {
    formUpdated(value) {
      this.formLeaveWithoutSave = value;
    },
    // check the route parameter and the store, and refresh it if needed
    refresh() {
      if (this.network == null || this.network.slug != this.slug) {
        // refresh it!
        this.busy = true;
        this.$http.get('networks/' + this.slug).then(resp => {
          this.network = resp.data;
          this.busy = false;
        });
      }
      if (this.id) {
        // refresh it!
        this.busy = true;
        this.$http.get('networks/' + this.slug + '/messages/' + this.id).then(response => {
          this.message = response.data.message;
          this.busy = false;
        });
      }
    },
  },
};
</script>